import { entity } from 'simpler-state';

import { isFlagEnabled } from '../util/flags/helpers';
import { FeatureFlagMap, FeatureFlags } from '../util/flags/types';

// Sync mirror of the flags for code outside React/Redux; every flag reads as disabled until the BFF has answered
const flagState = entity<FeatureFlagMap>({});

export default {
  get: (): FeatureFlagMap => flagState.get(),
  set: (flags: FeatureFlagMap): void => flagState.set(flags),
  isEnabled: (flag: FeatureFlags): boolean => isFlagEnabled(flagState.get(), flag),
  reset: (): void => flagState.set({}),
};
